import React from 'react';
import './ServicesGrid.css';

const ServiceGrid = () => {
  const services = [
    {
      id: 1,
      title: "Bolsas Pouch",
      description: "Empaques flexibles, funcionales y de alto impacto visual que realzan tu producto en el punto de venta.",
      productImage: "/images/services/pouch-img.png",
      bgImage: "/images/services/pouch.webp",
       link: "https://motistore.com/bolsa-pouch" 
    },
    {
      id: 2,
      title: "Gran Formato",
      description: "Impresión digital de gran escala para crear experiencias visuales que transforman espacios.",
      productImage: "/images/services/granformato-img.png",
      bgImage: "/images/services/granformato.webp",
      link: "/#/gran-formato" 
    },
    {
      id: 3,
      title: "Visual Merch",
      description: "Soluciones creativas para exhibir y comunicar tu marca de forma estratégica en retail.",
      productImage: "/images/services/visual-merch-img.png",
      bgImage: "/images/services/visual-merch.webp",
       link: "/#/visual-merch" 
    },
    {
      id: 4,
      title: "Brand experience",
      description: "Diseñamos experiencias memorables que conectan a tus clientes con la esencia de tu marca.",
      productImage: "/images/services/brand-experience-img.png",
      bgImage: "/images/services/brand-experience.webp",
      link: "/#/brand-experience" 
    },
    {
      id: 5,
      title: "Packaging de lujo",
      description: "Creamos empaques de lujo que transmiten exclusividad y elevan el valor de tu marca.",
      productImage: "/images/services/packaging-img.png",
      bgImage: "/images/services/packaging.webp",
      link: "/#/packaging" 
    },
    {
      id: 6,
      title: "Etiquetas y mangas",
      description: "Etiquetas autoadheribles y mangas termoencogibles de alta calidad para diferenciar tu producto.",
      productImage: "/images/services/etiquetas-img.png",
      bgImage: "/images/services/etiquetas.webp",
      link: "/#/etiquetas" 
    },
    {
      id: 7,
      title: "Estructuras y displays",
      description: "Diseños resistentes y personalizados que maximizan la viabilidad de tu marca en cualquier espacio.",
      productImage: "/images/services/banderas-img.png",
      bgImage: "/images/services/banderas.webp",
       link: "/#/estructuras" 
    }
  ];

  return (
    <div className="services-main-container" id='productos'>
      <div className="services-grid">
        {services.map((service) => (
          <div key={service.id} className="service-item">
            {/* Si el servicio tiene un link, envolvemos la imagen en un <a> */}
            <a href={service.link ? service.link : "#"} className="service-card-link">
              <div 
                className="service-card"
                style={{ backgroundImage: `url(${service.bgImage})` }}
              >
                <div className="product-image-container">
                  <img 
                    src={service.productImage} 
                    alt={service.title}
                    className="product-image"
                  />
                </div>
              </div>
            </a>

            <div className="text-content-srv">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceGrid;
